import DOMPurify from 'dompurify'

const PURIFY_CONFIG = {
    ADD_ATTR: ['target', 'rel'],
    FORBID_TAGS: ['style', 'form', 'input', 'iframe', 'object', 'embed', 'link', 'meta'],
    FORBID_ATTR: ['onerror', 'onload', 'onclick', 'onmouseover', 'onfocus', 'onblur', 'srcdoc', 'formaction']
}

export function sanitizeHtml(value) {
    if (value === null || value === undefined) {
        return ''
    }
    return DOMPurify.sanitize('' + value, PURIFY_CONFIG)
}

export const safeHtmlDirective = {
    beforeMount(el, binding) {
        el.innerHTML = sanitizeHtml(binding.value)
    },
    updated(el, binding) {
        if (binding.value === binding.oldValue) {
            return
        }
        el.innerHTML = sanitizeHtml(binding.value)
    }
}
